export const config = {
    hostUrl: 'https://api.finsentinel.finfactor.co.in',
    apiBasePrefixV1: '/finsentinel/api/v1',
    consentPath: "/consent",
};
